export default __webpack_public_path__ + "static/media/Firefox Mobile.446f3d8c.svg";